export default __webpack_public_path__ + "static/media/analisar-icon.6f69be5b.svg";